/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { useDeletePlanMutation, DeletePlanMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeletePlan({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deletePlanMutation, { client, ...rest }] = useDeletePlanMutation({
    onCompleted: (data: DeletePlanMutation) => {
      if (data.removePlan) {
        onSuccess();
        removeFromApolloCache(client.cache, `Plan:${id}`, "plans");
      } else {
        showError();
      }
    },
  });

  async function deletePlan(planId: string) {
    setId(planId);
    await deletePlanMutation({
      variables: {
        id: planId,
      },
    });
  }

  return [deletePlan, { client, ...rest }] as const;
}
